/**
 *    var uiFX = require('utils/ui-effects');
 *    uiFX.flashBg(this.select('viewItemArticleBiddingSelector'), 'warning');
 */
let uiEffects = {},
    _effectsSettings = {
        flashBgWarning: {
            cssClass: 'animate-flash-bg-red',
            animationTime: '800'
        },
        flashBgConfirm: {
            cssClass: 'animate-flash-bg-green',
            animationTime: '800'
        }
    };

let _cssAnimationEnd = function ($elem, cssClass) {
    $elem.removeClass(cssClass);
    $('body').off('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd webkitAnimationEnd oanimationend msAnimationEnd animationend');
};

let _cssAnimationStart = function ($elem, cssClass) {
    $elem.addClass(cssClass);
    $('body').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd webkitAnimationEnd oanimationend msAnimationEnd animationend',
        function () {
            _cssAnimationEnd($elem, cssClass);
        });
};

uiEffects.flashBg = function ($elem, flashType) {
    let settingsProp = 'flashBg' + (flashType.toLowerCase().charAt(0).toUpperCase() + flashType.slice(1)); // Uppercase the first char in 'flashtype' parameter
    if (_effectsSettings.hasOwnProperty(settingsProp)) {
        _cssAnimationStart($elem, _effectsSettings[settingsProp].cssClass);
    }
};

module.exports = uiEffects;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/ui-effects.js